<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-01">… Two, three or four simultaneous melodies which are constantly on the move, each going its own independent way. For this reason the underlying harmony is often hard to decipher, being veiled by a maze of passing notes and suspensions … Often chords are incomplete; only two tones are sounded so that one’s imagination has to fill in the missing third tone.</p>
<p class="fm-02"><i>A sentence describing Bach’s fugues, written by</i></p>
<p class="fm-03">L<span class="smallcaps">AWRENCE</span> A<span class="smallcaps">BBOT</span></p>
<p class="fm-04"><i>And for Rolls personally, the poem he found:</i> –</p>
<p class="fm-04">Home is where one starts from. As we grow older</p>
<p class="fm-04">The world becomes stranger, the pattern more complicated</p>
<p class="fm-04">Of dead and living. Not the intense moment</p>
<p class="fm-04">Isolated, with no before and after,</p>
<p class="fm-04">But a lifetime burning in every moment</p>
<p class="fm-04">And not the lifetime of one man only</p>
<p class="fm-04">But of old stones that cannot be deciphered,</p>
<p class="fm-04">There is a time for the evening under starlight,</p>
<p class="fm-04">A time for the evening under lamplight</p>
<p class="fm-04">(The evening with the photograph album).</p>
<p class="fm-04">Love is most nearly itself</p>
<p class="fm-04">When here and now cease to matter.</p>
<p class="fm-04">Old men ought to be explorers</p>
<p class="fm-04">Here or there does not matter</p>
<p class="fm-04">We must be still and still moving</p>
<p class="fm-04">Into another intensity</p>
<p class="fm-04">For a further union, a deeper communion …</p>
<p class="fm-04">… In my end is my beginning.</p>
<p class="fm-06">T. S. E<span class="smallcaps">LIOT</span>: ‘East Coker’</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?99ee4bda